import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignatureRequestSummaryViewModel } from '../../models/signature-request.viewmodel';
import { SignatureRequestStatusBadgeComponent } from '../signature-request-status-badge/signature-request-status-badge.component';

/**
 * A component that displays a summary of a signature request, including its ID, key timestamps, type, and status.
 */
@Component({
  selector: 'app-signature-request-summary-section',
  standalone: true,
  imports: [
    CommonModule,
    SignatureRequestStatusBadgeComponent
  ],
  templateUrl: './signature-request-summary-section.component.html',
  styleUrls: ['./signature-request-summary-section.component.scss']
})
export class SignatureRequestSummarySectionComponent {
  /**
   * The summary view model for the signature request, including its ID, key timestamps, type, and status.
   */
  @Input() signatureRequestSummary: SignatureRequestSummaryViewModel | null = null;
}
